import { Router } from '@angular/router';
import { Component, OnInit, SimpleChanges } from '@angular/core';
import { Chart } from 'angular-highcharts';
import { AppService } from '../../services/app.service';
import * as Moment from 'moment';

import { HttpHeaders } from '@angular/common/http';
import { extendMoment } from 'moment-range';
import { environment } from '../../../environments/environment';
import { UrlConfig } from '../../helpers/urlConfig';
import * as Highcharts from 'highcharts';
import { CommonService } from '../../shared/common.service';
import { MgmtScoreCardService } from 'src/app/services/mgmt-score-cardservice.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SelfServeService } from 'src/app/services/self-serve.service';
//import { MgmtComponent } from 'src/app/mgmt-score-card/mgmt/mgmt.component';
import { NavbarComponent } from '../navbar/navbar.component';

import { MgmtService } from '../../services/mgmt.service';
import { TeamWiseSalesService } from 'src/app/services/team-wise-sales.service';
import * as moment from 'moment';
import { PodTrackerService } from 'src/app/services/pod-tracker.service';
import { HttpService } from 'src/app/http.service';
import { runInThisContext } from 'vm';
import { AdvancePOSupplyService } from 'src/app/services/advance-posupply.service';

@Component({
  selector: 'app-advance-po-supply',
  templateUrl: './advance-po-supply.component.html',
  styleUrls: ['./advance-po-supply.component.css']
})
export class AdvancePOSupplyComponent implements OnInit {

  userId_val: any;
  dtOptionsenable: boolean;
  dtOptions: DataTables.Settings = {};
  reportlabel = '';
  dateRanges = { start_date: new Date(), end_date: new Date() };
  dateRange: any;
  viewDetailsTable: boolean;

  DateCalender: any;
  req_start_date: string;
  req_end_date: string;
  mngmt_data: any;
  requestBody = {};
  teamfinalpostObj: {};
  tableCondition: boolean;
  visualTable: boolean;
  TeamRegionsListObj: any = {};
  regions: any = [];
  public selectedRegions = [];
  public selectedTeams = [];
  public selectedCustomers = [];
  public selectedPlants = [];
  teams: any[];
  selectedL3: any[];
  customers: any[];
  selectedL4: any[];
  plants: any[];
  RkeyValue: any;
  filterData: any = {};

  dropdownSettings = {};
  teamdropdownSettings = {};
  customerdropdownSettings = {};
  plantdropdownSettings = {};
  categoriesdropdownSettings ={};
   
  Categories :any;
  category: any;
  selectedCategories: any[];
  exceldata: any;
    mngmt_data_PO: { table: {}; excel: any[]; };
    mngmt_data_MRN: { table: {}; excel: any[]; };

  constructor(private commonService: CommonService,
    private navbarTitle: NavbarComponent,
    private userId: AppService,
    private service: SelfServeService,
    private httpService: HttpService,
    private advancePOsupply: AdvancePOSupplyService){
    
      
      this.userId_val = this.userId.userDetails.email;
      this.reportlabel = this.navbarTitle.reportlabel;
  }
  ngOnInit() {
    debugger
   

  } 


  appendZero(number) {
    if (number > 9) {
      return number;
    } else {
      return '0' + number;
    }
  }
  getDateFormat(date) {
    if (!date) return;
    date = new Date(date);
    return date.getFullYear() + '-' + this.appendZero((date.getMonth() + 1)) + '-' + this.appendZero(date.getDate());
  }
  getDateRange(date = this.dateRange) {
    // this.advancePOsupply.getDateItemTrackingES().subscribe(dateRes => {
    //   // this.dateRanges = dateRes;
      // this.dateRanges.start_date = new Date(this.DateCalender.data.start_date);
      // this.dateRanges.end_date = new Date(this.DateCalender.data.end_date);
      this.req_start_date = this.getDateFormat(this.dateRanges.start_date);
      this.req_end_date = this.getDateFormat(this.dateRanges.end_date);

    //});
  }
  generateReports() {

    this.dtOptions = {};
    this.mngmt_data = {};
    this.requestBody = {};

    this.tableCondition = false;
    this.visualTable = false;
    const payload = this.generatePayload();
    const url = environment.baseURL_FREQ+'advance_po_supply';
    //const url = 'http://10.8.1.69:5023/freq_report/advance_po_supply'
    //this.advancePOsupply.saveInfo(url, payload).subscribe(resp => {
       this.advancePOsupply.saveInfo(url,payload).subscribe(res => {
  

        if(res['po_data']!=undefined && res['status']=='SUCCESS'){
          let reportRequest = {'username':this.userId_val,'report_name':this.reportlabel};
          this.userId.saveInfo(environment.user_tracking_api,reportRequest).subscribe(reportdata=>{
            console.log(reportdata);
          })
        }
        this.mngmt_data_PO = this.advancePOsupply.post(res);
        
        this.mngmt_data_MRN = this.advancePOsupply.postmrn(res);
        console.log('MRN-PO')
        if (this.mngmt_data_PO && this.mngmt_data_MRN) {
          console.log("PO")
          this.exceldata = this.mngmt_data_PO.excel;
          
          this.dtOptionsenable = true;
          if (this.dtOptions != null) {
            this.tableCondition = true;
            this.visualTable = true;
            this.service.exportAsExcelFile(this.mngmt_data_PO.excel, "PO");
            this.service.exportAsExcelFile(this.mngmt_data_MRN.excel,"MRN")
          }
        }
      });
  }
  generatePayload() {
    const payload = {
      "start_date": this.getDateFormat(this.dateRange[0]),
      "end_date": this.getDateFormat(this.dateRange[1])
    }
    console.log(payload)
    return payload;
  }
  ngOnChanges(changes: SimpleChanges) {
    this.getDateRange(this.dateRange);
  }

  calculateDateRange(value: Date): void {
    if(value) {
      var diff = Math.floor((Date.parse(value[1]) - Date.parse(value[0])) / 86400000);
      if(diff + 1 > 184) {
        this.commonService.showToast('max allowable date range is 6 months', 6);
        setTimeout(() => {
          this.dateRange = null;
        }, 100);
      } 
    }
  }

  refresh() {
   
    this.dateRange = null;

  }
 
}
